export default __webpack_public_path__ + "static/media/lesson1.6ac8f006.svg";